export const suppliersReceived = suppliers => ({
    type: 'SUPPLIERS_RECEIVED',
    payload: suppliers
});
